import React, {useContext} from 'react'
import {viewerGuard} from 'helpers/url'
import moment from 'moment'
import Label from 'components/label'
import Icon from 'components/icon'
import {enhancedWithRowData, enhancedWithSortColumns} from 'helpers/utils'
import {subdomainLink} from 'helpers/url'

import {TeacherContext} from 'teacher/context'

function DownloadLogHeader ({sortColumns, title}) {
  const {translate} = useContext(TeacherContext)
  const active = sortColumns && sortColumns.id == title
  const direction = active ? (sortColumns.sortAscending ? 'ascending' : 'descending') : ''
  return (
    <span className="sorted-column-wrapper">
      <span className={direction}/>
      <span>{translate(`${title}_download_log_header`)}</span>
    </span>
  )
}

function EmptyHeader () { return (<span />) }

function LabelColumn (maxLength) {
  return ({value}) => {
    return <Label {...{value, maxLength}} />   
  }
}

function GroupColumn ({rowData}) {
  const {group} = rowData
  return (<>{group && <Label value={group.name} maxLength={30} />}</>)
}

function DownloadLinksColumn ({rowData}) {
  const {stamps, lesson = {}} = rowData
  const {translate, languageId} = useContext(TeacherContext)
  const title = stamps
    .map(s => moment(s).format('MM/DD/YYYY, hh:mm a'))
    .join(`
`)
  return (
    <div className="links">
      <div className="lesson-link">
        <label title={title}>
          <Icon name="schedule" />
        </label>
      </div>
    {!lesson.id && (<div className="lesson-preview" style={{visibility: 'hidden'}}>
        <a target="_blank" href="#" title={translate('preview_tooltip_title')}>
          <Icon name="preview" />
        </a>
      </div>)}
    {lesson.id && (<div className="lesson-preview">
        <a {...viewerGuard({target: "_blank", href: subdomainLink('preview', '#', languageId, 'lesson', lesson.id)})} title={translate('preview_tooltip_title')}>
          <Icon name="preview" />
        </a>
      </div>)}
    </div>
  )
}

function DownloadCountColumn ({rowData}) {
  const {stamps} = rowData
  return (
    <div className="download-count">
      {stamps.length}
    </div>
  )
}

function OnlineViewsColumn ({rowData}) {
  const {views} = rowData
  return (
    <div className="online-views">
      {views.length}
    </div>
  )
}

function FirstDownloadColumn ({rowData}) {
  const {stamps: [first]} = rowData
  return (
    <div className="first-download">
      {first && moment(first).format('MM/DD/YYYY, hh:mm a')}
    </div>
  )
}

function StartColumn ({rowData}) {
  const {start} = rowData
  return (
    <div className="start">
      {moment(start).format('MM/DD/YYYY')}
    </div>
  )
}

function LessonColumn ({rowData}) {
  const {lesson, title} = rowData
  return (
    <div className="lesson">
      <Label value={lesson ? `${lesson.id} - ${lesson.name}` : title || ""} maxLength={200} />
    </div>
  )
}


const map = {
  headers: {DownloadLogHeader: enhancedWithSortColumns(DownloadLogHeader), EmptyHeader},
  columns: {
    GroupColumn: enhancedWithRowData(GroupColumn),
    LessonColumn: enhancedWithRowData(LessonColumn),
    StartColumn: enhancedWithRowData(StartColumn),
    FirstDownloadColumn: enhancedWithRowData(FirstDownloadColumn),
    OnlineViewsColumn: enhancedWithRowData(OnlineViewsColumn),
    DownloadCountColumn: enhancedWithRowData(DownloadCountColumn),
    DownloadLinksColumn: enhancedWithRowData(DownloadLinksColumn),
    LabelColumn
  }
}

export default map


